import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { HelperService } from '../helper.service';

export interface DialogData {
  errorType: string;
  platform: string,
}

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss']
})


export class MessageDialogComponent implements OnInit {
  href = new URL(window.location.href);
  
  constructor(
    private helper: HelperService,
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  tryAgain(): void {
    this.helper.forceReloadSamePage();
    this.dialogRef.close();
  }

  goToApp() {
    if(this.data.platform == "m"){
      window.open("sadanappkwt://sadankwt.com/");
    }else{
      const url = environment.configs.appHost;//this.href.protocol + "//" + this.href.host + '/home/';
      window.location.href = url;
    }
  }

}
